import React from "react";
import PropTypes from "prop-types";

class Autocomplete extends React.Component {
  static propTypes = {
      suggestions: PropTypes.instanceOf(Array)
   };

   static defaultProps = {
      suggestions: [],
   };

   constructor(props) {
      super(props);

      this.state = {
         // The active selection's index
         activeSuggestion: 0,
         // The suggestions that match the user's input
         filteredSuggestions: [],
         // Whether or not the suggestion list is shown
         showSuggestions: false,
         // What the user has entered
         userInput: "",
      };
   }
   componentDidMount() {
      if( this.props.clear ){
         this.clearInput();
      }
   }
   onChange = e => {
      const { suggestions } = this.props;
      const userInput = e.currentTarget.value.replace("'","-");
      
      // Filter our suggestions that don't contain the user's input
      const filteredSuggestions = suggestions.filter(suggestion =>
         // console.log(suggestion);
         suggestion.toLowerCase().indexOf(userInput.toLowerCase()) > -1
      );
     
      this.setState({
         activeSuggestion: 0,
         filteredSuggestions,
         showSuggestions: true,
         userInput: e.currentTarget.value
      });
   };

   onClick = e => {
      const nombre = e.currentTarget.innerText;
      this.props.select(nombre);
      this.setState({
         activeSuggestion: 0,
         filteredSuggestions: [],
         showSuggestions: false,
         userInput: ""
      });
   };
   clearInput = () => {
      this.setState({
         activeSuggestion: 0,
         filteredSuggestions: [],
         showSuggestions: false,
         userInput: ""
      });
   }
   onKeyDown = e => {
      const { activeSuggestion, filteredSuggestions } = this.state;
      // User pressed the enter key
      if (e.keyCode === 13 ) {
         this.props.select(filteredSuggestions[activeSuggestion]);
         this.clearInput();
      }
      // User pressed the up arrow
      else if (e.keyCode === 38 || (e.keyCode > 47 && e.keyCode < 58) ) {
         if (activeSuggestion === 0) {
            return;
         }
         this.setState({ activeSuggestion: activeSuggestion - 1 });
      }
      // User pressed the down arrow
      else if (e.keyCode === 40 || (e.keyCode > 47 && e.keyCode < 58)) {
         if (activeSuggestion - 1 === filteredSuggestions.length) {
            return;
         }
         this.setState({ activeSuggestion: activeSuggestion + 1 });
      }
   };

   render() {
      const {
         onChange,
         onClick,
         onKeyDown,
         state: {
            activeSuggestion,
            filteredSuggestions,
            showSuggestions,
            userInput
         }
      } = this;
      let suggestionsListComponent;
      let status = null;
      if (showSuggestions && userInput) {
         if (filteredSuggestions.length) {
            suggestionsListComponent = (
               <ul className="listSearch">
                  {filteredSuggestions.map((suggestion, index) => {
                     let className;
                     status = suggestion.split('/');
                     suggestion = status[0]+' / '+status[1]+' / '+status[2];
                     status = status.pop();
                     status = status > 0 ? 'none' : 'bgred';
                     // Flag the active suggestion with a class
                     if (index === activeSuggestion) {
                        className = "suggestion-active";
                     }
                     return (
                        <li className={className+' '+status} key={suggestion} onClick={onClick}>
                           {suggestion}
                        </li>
                     );
                  })}
               </ul>
            );
         } else {
            suggestionsListComponent = (
               <ul className="listSearch">
                  <li className="suggestion-active">¡Producto no existente!</li>
               </ul>
            );
         }
      }

      return (
      <div className="bar-search">
         <div className="theInput">
            <div className="listSearch">
               <input
                  type="text"
                  onChange={onChange}
                  onKeyDown={onKeyDown}
                  value={userInput}
               />
               {suggestionsListComponent}
            </div>
            <i className="icon-lupa"></i>
         </div>
         <div id="clearInput" className="closeSearch" onClick={this.clearInput} title="Limpiar Casilla">x</div>
      </div>
    );
  }
}

export default Autocomplete;
